import { render, staticRenderFns } from "./RequisiteSimpleDataSelect.vue?vue&type=template&id=544b8e5c&scoped=true"
import script from "./RequisiteSimpleDataSelect.vue?vue&type=script&lang=js"
export * from "./RequisiteSimpleDataSelect.vue?vue&type=script&lang=js"
import style0 from "./RequisiteSimpleDataSelect.vue?vue&type=style&index=0&id=544b8e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544b8e5c",
  null
  
)

export default component.exports